import { useEffect, useRef } from 'react'

import { getUpNext } from '../../../actions/contentActions'
import { useVideoPlayerData } from '../VideoPlayerContext'
import { useAppSelector } from '../../../hooks/useStore'

export function useUpNext() {
  const { videoDetails, upNextEnabled } = useAppSelector(
    (state) => state.content
  )
  const { playerState, setUpNextData } = useVideoPlayerData()
  const timeRemaining = playerState.duration - playerState.currentProgress
  const hasCalledForCurrentSlugRef = useRef(false)
  const isContentFullLengthAndReachedThreshold =
    videoDetails.contentType === 'full_length' && timeRemaining <= 120

  const callGetUpNext = async () => {
    try {
      const upNextData = await getUpNext(videoDetails.slug)
      if (upNextData) {
        setUpNextData(upNextData)
      }
    } catch (error) {
      console.info(`Could not find upNext for ${videoDetails.slug}`)
    }
  }
  useEffect(() => {
    hasCalledForCurrentSlugRef.current = false
  }, [videoDetails.slug])

  useEffect(() => {
    if (
      upNextEnabled &&
      playerState.status === 'playing' &&
      !hasCalledForCurrentSlugRef.current &&
      (isContentFullLengthAndReachedThreshold ||
        videoDetails.contentType !== 'full_length')
    ) {
      callGetUpNext()
      hasCalledForCurrentSlugRef.current = true
    }
  }, [
    upNextEnabled,
    videoDetails.contentType,
    isContentFullLengthAndReachedThreshold,
    playerState.status,
    videoDetails.slug,
  ])
}
